import MessageSequencer from './MessageSequencer';

export default MessageSequencer;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/messageSequencer/index.js